window.deliveryFee = 5;
window.taxes = 2;